// extracted by mini-css-extract-plugin
module.exports = {"gridY":"GridBackground_gridY__KUfyR","gridX":"GridBackground_gridX__8vDdY"};